import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import Breadcrumbs from './Breadcrumbs';

const QUERY = gql`
query BreadcrumbsQuery($lang: String!, $path: String!) {
  breadcrumb(lang: $lang, path: $path) {
    title
    path
  }
  teksti(lang: $lang, _id:[
    "sakums"
  ]) {
    _id
    text
  }
}`;

const queryOptions = {
  options: ({ lang, path }) => ({
    fetchPolicy: 'cache-first',
    skip: !lang || !path,
    variables: {
      lang,
      path,
    }
  }),
  props: props => {
    const { data: {
      breadcrumb,
      teksti,
    }} = props;
    return {
      items: breadcrumb || [],
      teksti,
    }
  }
}

// FIXME: Pēc history navigācijas GraphQL
// pieprasījums nenotiek un items ir tukšs

const BreadcrumbsConnected = ({items, teksti, lang}) => {
  return items && (
    <Breadcrumbs
      items={items}
      teksti={teksti}
      lang={lang}
      /* truncationWidth={150} */
    />
  )
}

export default compose(
  graphql(QUERY, queryOptions)
)(BreadcrumbsConnected)



// WEBPACK FOOTER //
// ./src/elements/Breadcrumbs/BreadcrumbsConnected.jsx